<template>
  <div class="footer">
    <div class="top">
      <div class="code">
        <img src="@/assets/image/home/weitu.png" alt="">
        <p>{{ $t('footer.OfficialWeChat') }}</p>
      </div>
      <div class="Word">
        <img v-if="!isEnglish" src="@/assets/image/home/logo@2x.png" alt="">
        <span v-else style="display: flex;align-items: center;padding-left: 75px;">
          <img src="@/assets/image/home/logo-65.png" alt="" style="width: 40px">
          <span style="font-size: 16px;font-weight: 600;margin-left: 10px;transform: translateY(-5px)">Ocean Remote Sensing Big Data Information Service and Decision Center</span>
        </span>
        <p>{{ $t('footer.Address') }}:{{ $t('footer.Address2') }}</p>
        <p class="b1">© {{ $t('footer.copyright') }}</p>
        <p class="b2">{{ $t('footer.TechnicalSupport') }}：{{ $t('footer.SunYatsenUniversity') }}</p>
        <p>{{ $t('footer.InternetContentProvider') }}</p>
      </div>
    </div>
    <div class="y-l">
      {{ $t('footer.RelatedLinks') }}：
      <span @click="goR('https://www.sml-zhuhai.cn/')">{{ $t('footer.Address3') }}</span>
      <span @click="goR('https://www.sysu.edu.cn/')">{{ $t('footer.SunYatsenUniversity') }}</span>
      <span @click="goR('https://api2.illkx.win/')"> {{ $t('footer.Portal') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  computed: {},
  data() {
    return {
      isEnglish: false
    }
  },
  created() {
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
  methods: {
    goR(val) {
      window.open(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  @include footer_bg();
  height: 270px;

  .top {
    color: white;
    height: 210px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .y-l {
    text-align: center;
    margin-top: 18px;
    color: #fff;
    font-size: 16px;

    a {
      margin: 0 12px;
      color: #fff;
      text-decoration: none;
    }

    span {
      cursor: pointer;
      margin: 0 12px;
      color: #fff;
    }

    span:hover {
      color: #3390F8;
    }
  }

  .code {
    margin-right: 121px;
    text-align: center;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    @include footer_co();

    img {
      width: 107px;
      height: 107px;
      border: 5px solid rgba(2, 105, 255, 0.4);
      border-radius: 6px;
    }
  }

  .Word {
    text-align: center;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    @include footer_co();

    img {
      width: 376px;
      height: 38px;
      margin: 0 0 11px 0;
    }
  }

  .b1 {
    margin: 5px 0 3px 0;
  }

  .b2 {
    margin: 3px 0 5px 0;
  }
}
</style>